/**
 * download the blob, and the link will be revoked after download
 * @param blob data blob
 * @param fileName file name
 */
export default function downloadBlob(blob: Blob, fileName: string) {
  // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    // For other browsers: create a link pointing to the ObjectURL containing the blob.
    const objUrl = window.URL.createObjectURL(blob);

    let link = document.createElement("a");
    link.href = objUrl;
    link.download = fileName;
    link.click();

    // For Firefox it is necessary to delay revoking the ObjectURL.
    setTimeout(() => {
      window.URL.revokeObjectURL(objUrl);
    }, 4e4);
  }
}
